import { useState } from 'react'
import { lumi } from '@/lib/lumi'

interface PageSetting {
  _id?: string
  settingKey: string
  imageUrl?: string
  imageData?: string
  updatedAt: string
}

export function usePageSettings() {
  const [loading, setLoading] = useState(false)

  // Buscar TODAS as configurações de uma vez (1 query em vez de N)
  const getAllSettings = async (): Promise<Record<string, string>> => {
    try {
      const { list } = await lumi.entities.page_settings.list({
        limit: 30,
        sort: { updatedAt: -1 }
      })
      const map: Record<string, string> = {}
      if (list) {
        for (const item of list) {
          if (item.settingKey && item.imageData && !map[item.settingKey]) {
            map[item.settingKey] = item.imageData
          }
        }
      }
      return map
    } catch {
      return {}
    }
  }

  // Buscar uma configuração específica (mantido para compatibilidade)
  const getSetting = async (settingKey: string): Promise<string> => {
    try {
      const { list } = await lumi.entities.page_settings.list({
        filter: { settingKey },
        limit: 1,
        sort: { updatedAt: -1 }
      })
      if (list && list.length > 0) return list[0].imageData || ''
      return ''
    } catch {
      return ''
    }
  }

  // Salvar ou atualizar uma configuração
  const saveSetting = async (settingKey: string, imageData: string) => {
    setLoading(true)
    try {
      console.log('Iniciando salvamento de:', settingKey)
      
      // Verificar se já existe
      const { list } = await lumi.entities.page_settings.list({
        filter: { settingKey },
        limit: 1
      })

      const settingData = {
        settingKey,
        imageData,
        updatedAt: new Date().toISOString()
      }

      if (list && list.length > 0) {
        // Atualizar existente
        console.log('Atualizando registro existente:', list[0]._id)
        const result = await lumi.entities.page_settings.update(list[0]._id, settingData)
        console.log('Resultado da atualização:', result)
      } else {
        // Criar novo
        console.log('Criando novo registro')
        const result = await lumi.entities.page_settings.create(settingData)
        console.log('Resultado da criação:', result)
      }
      
      console.log('✅ Configuração salva com sucesso:', settingKey)
      return true
    } catch (error) {
      console.error('❌ Erro ao salvar configuração:', error)
      alert('Erro ao salvar imagem. Por favor, tente novamente.')
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    getSetting,
    getAllSettings,
    saveSetting,
    loading
  }
}
